<template>
  <transition name="loadplan">
    <div class="load-mask" v-if="!loadFlag">
      <div class="load-plan-box">
        <div class="load-plan"></div>
        <div class="load-plan-text">{{ p }}%</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LoadPopup',
  props: {
    progress: Number,
    loadFlag: Boolean
  },
  computed: {
    p () {
      return Math.round(this.progress * 100)
    }
  }
}
</script>

<style scoped>
.load-mask{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  background-color: #fbdde4;
}
.load-plan-box{
  position: absolute;
  top: 42%;
  right: 0;
  left: 0;
  width: 2.39rem;
  height: .66rem;
  margin: auto;
  background: url('../../assets/images/logo.png') center no-repeat;
  background-size: contain;
}
.load-plan {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.load-plan-text {
  position: absolute;
  top: 130%;
  left: 0;
  width: 100%;
  text-align: center;
  color: #333;
}
.loadplan-enter-active,
.loadplan-leave-active {
  transition: transform .4s cubic-bezier(0.32, 0.08, 0.24, 1);
}
.loadplan-enter,
.loadplan-leave-to {
  transform: translate3d(0, -100%, 0);
}
</style>
